import { c as _c } from "react/compiler-runtime";
import { IcoDotSmall16 } from '@onefootprint/icons';
import { Shimmer } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
const HEADER_HEIGHT = '32px';
const Loading = () => {
  const $ = _c(5);
  const {
    t
  } = useTranslation("security-logs");
  let t0;
  if ($[0] !== t) {
    t0 = t(_temp);
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [1, 2].map(_temp2);
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <div className="flex flex-col gap-4" aria-label={t0}>{t1}</div>;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default Loading;
function _temp($) {
  return $.loadingAria;
}
function _temp2(i) {
  return <div key={i} className="grid relative h-auto items-start justify-start grid-cols-[24px_minmax(0,1fr)] [grid-template-areas:'icon_time'_'line_content'] md:grid-cols-[146px_24px_1fr] md:[grid-template-areas:'time_icon_content'_'empty_line_content']" style={{
    gridTemplateRows: `${HEADER_HEIGHT} auto`
  }}><div className="[grid-area:time] flex flex-row items-center gap-4" style={{
      height: HEADER_HEIGHT
    }}><Shimmer height="20px" width="59px" /><Shimmer height="20px" width="65px" /></div><div className="[grid-area:line] absolute top-0 bottom-0 left-1/2 -translate-x-1/2 w-[1px] h-full bg-[var(--border-color-primary)]" style={{
      height: "calc(100% + 20px)"
    }} /><div className="[grid-area:icon] flex items-center justify-center bg-primary" style={{
      minHeight: HEADER_HEIGHT
    }}><IcoDotSmall16 className="[&>path]:fill-bg-senary" /></div><div className="grid flex-col gap-2 ml-1 mt-1 pt-0.5 grid-cols-[minmax(0,1fr)] md:grid-cols-[1fr]" style={{
      gridArea: "content",
      gridTemplateAreas: "\"header\" \"body\"",
      gridTemplateRows: "auto auto"
    }}><div className="[grid-area:header] flex items-start justify-start"><Shimmer height="20px" width="624px" className="max-md:max-w-full" /></div><span className="mt-2 h-auto"><Shimmer height="80px" width="960px" className="max-md:max-w-full" /></span></div></div>;
}